import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({
    providedIn: 'root'
})
export class CuSeniorService extends ApiService {

    index(params: any = {}) {
        return super.get('/cu-seniors', params);
    }

    store(body: any) {
        return super.post('/cu-seniors', body);
    }

    edit(cuSeniorId: number) {
        return super.get(`/cu-seniors/${cuSeniorId}/edit`);
    }

    update(cuSeniorId: number, body: any) {
        return super.put(`/cu-seniors/${cuSeniorId}`, body);
    }

    select(params: any = {}) {
        return super.get(`/cu-seniors/select`, params);
    }
}
